const API_BASE =
  String(
    process.env.REACT_APP_API_URL ||
    "https://api.psyassist.com.br"
  ).replace(/\/$/, "");

const ADMIN_TOKEN_KEY =
  "psy_admin_token";

const ADMIN_USER_KEY =
  "psy_admin_user";

export function getAdminToken() {
  return (
    sessionStorage.getItem(
      ADMIN_TOKEN_KEY
    ) ||
    localStorage.getItem(
      ADMIN_TOKEN_KEY
    ) ||
    ""
  );
}

export function saveAdminSession({
  accessToken,
  user,
  remember = false,
}) {
  clearAdminSession();

  const storage =
    remember
      ? localStorage
      : sessionStorage;

  storage.setItem(
    ADMIN_TOKEN_KEY,
    String(
      accessToken || ""
    )
  );

  storage.setItem(
    ADMIN_USER_KEY,
    JSON.stringify(
      user || {}
    )
  );
}

export function clearAdminSession() {
  for (
    const storage
    of [
      localStorage,
      sessionStorage,
    ]
  ) {
    storage.removeItem(
      ADMIN_TOKEN_KEY
    );

    storage.removeItem(
      ADMIN_USER_KEY
    );
  }
}

export function getStoredAdminUser() {
  const raw =
    sessionStorage.getItem(
      ADMIN_USER_KEY
    ) ||
    localStorage.getItem(
      ADMIN_USER_KEY
    );

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(
      raw
    );
  } catch {
    return null;
  }
}

async function readJson(
  response
) {
  const text =
    await response.text();

  if (!text) {
    return {};
  }

  try {
    return JSON.parse(
      text
    );
  } catch {
    return {
      message:
        text,
    };
  }
}

export async function adminRequest(
  path,
  options = {}
) {
  const token =
    getAdminToken();

  const headers = {
    ...(options.headers ||
      {}),
  };

  if (
    options.body &&
    !headers[
      "Content-Type"
    ]
  ) {
    headers[
      "Content-Type"
    ] =
      "application/json";
  }

  if (token) {
    headers.Authorization =
      `Bearer ${token}`;
  }

  const response =
    await fetch(
      `${API_BASE}${path}`,
      {
        ...options,
        headers,
      }
    );

  const data =
    await readJson(
      response
    );

  if (
    response.status ===
      401 ||
    response.status ===
      403
  ) {
    if (
      path !==
      "/psy/admin/login"
    ) {
      clearAdminSession();
    }
  }

  if (
    !response.ok
  ) {
    const error =
      new Error(
        data?.message ||
        "Não foi possível concluir a operação."
      );

    error.status =
      response.status;

    error.data =
      data;

    throw error;
  }

  return data;
}

export async function adminLogin({
  email,
  senha,
}) {
  return await adminRequest(
    "/psy/admin/login",
    {
      method:
        "POST",
      body:
        JSON.stringify({
          email,
          senha,
        }),
    }
  );
}
